export default __webpack_public_path__ + "static/tad_mainshop_1-bfa879b4b756d74d2f0342e26562ece5.jpg";